import { useDialogCloseGuard } from '@ff-it/ui';
import { useForm } from 'react-final-form';

export function DirtyDialogFormGuard(): null {
  const form = useForm();

  useDialogCloseGuard(async () => {
    if (form.getState().dirty) {
      return window.confirm('Are you sure you want to close dirty form?');
    }
    return true;
  });
  return null;
}
